import $apiJSON from 'http/apiJSON'

const BASE = '/admin-panel/reports'

const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

const downloadFile = async (path, params, fallbackName) => {
  const res = await $apiJSON.get(path, { params, responseType: 'blob' })
  let filename = fallbackName
  const cd = res.headers?.['content-disposition'] || res.headers?.['Content-Disposition']
  if (cd) {
    const m = /filename="?([^";]+)"?/i.exec(cd)
    if (m && m[1]) filename = decodeURIComponent(m[1])
  }
  triggerDownload(new Blob([res.data]), filename)
}

export const getForm1NK = (year) => $apiJSON.get(`${BASE}/form-1nk/`, { params: { year } })
export const downloadForm1NK = (year, fmt = 'xlsx') =>
  downloadFile(`${BASE}/form-1nk/${fmt}/`, { year }, `form-1nk-${year}.${fmt}`)

export const getContingent = (params = {}) => $apiJSON.get(`${BASE}/contingent/`, { params })
export const downloadContingent = (params = {}, fmt = 'xlsx') => {
  const datePart = params?.date || new Date().toISOString().slice(0, 10)
  return downloadFile(`${BASE}/contingent/${fmt}/`, params, `contingent-${datePart}.${fmt}`)
}

export const getAccreditation = (year) => $apiJSON.get(`${BASE}/accreditation/`, { params: { year } })
export const downloadAccreditation = (year, fmt = 'xlsx') =>
  downloadFile(`${BASE}/accreditation/${fmt}/`, { year }, `accreditation-${year}.${fmt}`)

export const previewForm1NK = (params = {}) => $apiJSON.get(`${BASE}/form-1nk/`, { params })
export const exportForm1NK = (params = {}, format = 'xlsx') =>
  $apiJSON.get(`${BASE}/form-1nk/${format}/`, { params, responseType: 'blob' })

export const previewContingent = (params = {}) => $apiJSON.get(`${BASE}/contingent/`, { params })
export const exportContingent = (params = {}, format = 'xlsx') =>
  $apiJSON.get(`${BASE}/contingent/${format}/`, { params, responseType: 'blob' })

export const previewAccreditation = (params = {}) => $apiJSON.get(`${BASE}/accreditation/`, { params })
export const exportAccreditation = (params = {}, format = 'xlsx') =>
  $apiJSON.get(`${BASE}/accreditation/${format}/`, { params, responseType: 'blob' })

export const listReports = () => Promise.resolve({ data: [] })

export default {
  listReports,
  getForm1NK,
  downloadForm1NK,
  getContingent,
  downloadContingent,
  getAccreditation,
  downloadAccreditation,
  previewForm1NK,
  exportForm1NK,
  previewContingent,
  exportContingent,
  previewAccreditation,
  exportAccreditation,
}
